import { Injectable } from "@angular/core";
import { HttpDataSource } from "@jeanologia/ng-interfaces";

@Injectable()
export class CouponsDataSource extends HttpDataSource {
	public redeemCode(code: string) {
		const path = this.getPath();
		const new_path = `${path}/validate/${code}`;
		this.setPath(new_path);
		this.postData({});
		this.setPath(path);
	}
}
